
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"6","viewBox":"0 0 9 6"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('g',{attrs:{"transform":"translate(-0.2, 0)"}},[_c('path',{attrs:{"d":"M7 0.6C7.4 0.2 8 0.2 8.4 0.6 8.8 1 8.8 1.6 8.4 2L4.7 5.7 1 2C0.6 1.6 0.6 1 1 0.6 1.4 0.2 2 0.2 2.4 0.6L4.7 2.9 7 0.6Z"}})])])])
          )
        }
      }
    